<template>
  <div>
      <!-- <v-btn @click="getTickets()">SHOW List</v-btn> -->
      <!-- <v-btn @click="getTicketSummary()">summary</v-btn> -->
      <!-- <v-btn @click="importExampleTicket()">Import Example</v-btn>
      <v-btn @click="dropExampleTicket()">Drop Example</v-btn>
      <v-btn
        class="ma-2"
        color="primary"
        @click="expand = !expand, expand2=false"
      >
        體驗邀請獎勵
      </v-btn>
      <v-btn
        class="ma-2"
        color="primary"
        @click="expand2 = !expand2, expand=false"
      >
        點數儲值
      </v-btn> -->
      <!-- <hr> -->
      <v-container class="ticket_wrap wrap">
        <h1 class="mb-5">LINE Point 點數管理</h1>
        <v-row class="mb-5">
          <v-spacer></v-spacer>
          <v-btn
            class="ma-md-2 pa-md-5 mr-2 pa-3"
            color="primary"
            @click="expand = !expand, expand2=false"
          >
            體驗邀請獎勵
          </v-btn>
          <v-btn
            class="ma-md-2 pa-md-5 mr-2 pa-3"
            color="primary"
            @click="expand2 = !expand2, expand=false, showLinePointHint()"
          ><v-icon style="margin-top:1px;">mdi-plus</v-icon>
            點數儲值
          </v-btn>

        </v-row>
        <v-expand-transition>
          <v-card
            v-show="expand"
            width="100%"
            class="mx-auto my-5"
            color="rgba(116,179,107,0.1)"
          >
            <v-card-title>還沒購買LINE Point? 我們提供範例序號讓您試用體驗流程</v-card-title>
            <v-card-text>
              匯入範例後，即可在邀請活動當中設定獎勵，體驗實際兌換流程。<br/>
              ※注意事項※
              <ul>
                <li>本範例序號僅供測試，無法實際兌換任何點數。</li>
                <li>體驗後，請「清除範例」，否則會影響後續正式序號的發送。</li>
                <li>如未清除範例導致活動進行中碰到任何問題，本公司一律不付任何責任。</li>
                <li>如欲購買LINE Point，請洽荔枝智慧客服窗口。</li>
              </ul>
            </v-card-text>
            <v-card-actions class="pa-5">
              <v-btn @click="importExampleTicket()" color="primary">匯入範例</v-btn>
              <v-btn @click="dropExampleTicket()" color="primary" plain style="border:1px solid #74b36b;">清除範例</v-btn>
            </v-card-actions>
          </v-card>
          
        </v-expand-transition>
        <v-expand-transition>
          <v-card v-show="expand2" color="rgba(116,179,107,0.1)" class="my-5">
              <v-card-title>
              LINE Point 點數儲值
              </v-card-title>
              <v-card-text class="pa-4">
                <v-row>
                  <v-col class="flex-grow-0 text-center pa-5">
                    <qrcode-vue value="https://line.me/R/ti/p/@585cvzsv" size="100" level="H"></qrcode-vue>
                    <a href="https://line.me/R/ti/p/@585cvzsv" target="_blank" class="nowrap mt-2 font-weight-bold" style="text-decoration:underline; display:block;">加入荔枝官方帳號</a>
                  </v-col>
                  <v-col class="flex-grow-1 pt-5" style="line-height:32px;">
                    請洽荔枝智慧客服購買LINE Point點數。
                    <br/>
                    【聯繫方式】<br/>
                    LINE官方帳號：請點擊左方連結或掃QRcode加入，透過一對一聊天取得客服。<br/>
                    客服信箱：support@lychee.tw
                  </v-col>
                </v-row>
              </v-card-text>
          </v-card>
        </v-expand-transition>
        <v-data-table
        :headers="headers"
        :items="tickets"
        :items-per-page="100"
        :loading="isloading"
        hide-default-footer
        class="elevation-1 mb-5"
        >
        </v-data-table>
        <div class="text-center">
          <v-pagination
            v-model="page"
            :length="count"
            @input="getTickets"
          ></v-pagination>
        </div>
      </v-container>
  </div>
</template>

<script>
var host_url = process.env.VUE_APP_HOST_URL;
import { mapGetters } from 'vuex'
import moment from 'moment'

export default {
  name: "Ticket",
  components: { moment,QrcodeVue },
  data() {
    return {
      tickets: [],
      headers: [
          {
              text: '序號',
              align: 'left',
              sortable: false,
              value: 'code',
              width: 'auto',
          },
          { text: '種類', value: 'type', width: 200,},
          { text: '狀態', value: 'status_text',width: 200,},
          { text: '', value: '',width: 200},
      ],
      page: 1 ,
      count: 1,
      testPoint : false,
      expand: false,
      expand2: false,
    }
  },
  computed:{
        ...mapGetters(['isloading'])
    },
  filters: {
    moment: function (date) {
        return moment(date).format('YYYY-MM-DD HH:mm:ss');
    }
  },
  mounted () {
    this.getTickets()
    if(this.$route.params.point == 'pointTest'){
      this.testPoint = true
    }else{
      this.testPoint = false
    }
  },
  methods: {
    moment(date) {
            let a = moment(date).tz("Asia/Taipei");
            return a;
    },
    showLinePointHint() {
      this.$gtag.event('click_點數儲值', {'event_category': "ticket", 'event_label': "action"})
    },
    async getTickets() {
        try {
            let resp = await axios.get(`${host_url}/tickets/?page=${this.page}`);
            console.log(resp.data);
            this.count = Math.ceil(resp.data.count/100)
            let data = resp.data.results
            data.forEach(el=>{
              // IS_NEW = 1
              // # IS_ALLOCATED = 10
              // IS_SENT = 20
              // IS_RECEIVED = 30
              // IS_USED = 40
              let status_text = ''
              switch (el.status){
                case 1:
                  status_text = '可使用'
                  break
                case 20:
                case 30:
                  status_text = '已發送'
                  break
                case 40:
                  status_text = '已被兌換'
                  break
              }
              el.status_text = status_text
            })
            this.tickets = data
            console.log(this.tickets);
        } catch (error) {
            console.log(error);
            throw new Error('Get bots Fail')
        }
    },

    async importExampleTicket() {
        try {
            let payload = {
                "type": "example",
                // "point" : "10"
            }
            let resp = await axios.post(host_url + "/tickets/import/", payload);
            console.log(resp.data);
            this.getTickets()
            this.$gtag.event('importExampleTicket', {'event_category': "ticket", 'event_label': "action"})
        } catch (error) {
            console.log(error);
            throw new Error('import example Fail')
        }
    },
    async dropExampleTicket() {
        try {
            let payload = {
                "type": "example"
            }
            let resp = await axios.post(host_url + "/tickets/drop/", payload);
            console.log(resp.data);
            this.page = 1
            this.getTickets()
            this.$gtag.event('dropExampleTicket', {'event_category': "ticket", 'event_label': "action"})
        } catch (error) {
            console.log(error);
            throw new Error('import example Fail')
        }
    },
  },
};
</script>
<style lang="scss" scoped>
@media(min-width: 1441px){
  .ticket_wrap{
    max-width: 1200px;
}
}
</style>